import { createRoutine } from 'redux-saga-routines'
import { INoteState } from './note.interface'
import { mergeArrayAndOverrideDuplicates } from '../utils/index.common'

const initialDeviceState: INoteState = {
  notes: [],
  selectedNote: {
    content: '',
    createdAt: new Date(),
    createdBy: 0,
    deletedAt: new Date(),
    deletedBy: 0,
    id: 0,
    patientId: 0,
    updatedAt: new Date(),
    updatedBy: 0,
  },
  error: false,
  loading: false,
  notesListLoading: false,
  meta: {
    perPage: 0,
    totalPages: 0,
    totalResults: 0,
    curPage: 0,
  },
}

export const addNote = createRoutine('ADD_NOTE')
export const showNote = createRoutine('SHOW_NOTE')
export const editNote = createRoutine('EDIT_NOTE')
export const getAllNotes = createRoutine('GET_ALL_NOTES')
export const deleteNote = createRoutine('DELETE_NOTE')

export default function note(state = initialDeviceState, action: any) {
  switch (action.type) {
    case addNote.TRIGGER: {
      return { ...state, loading: true, error: false, success: false }
    }
    case addNote.SUCCESS: {
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        notes: mergeArrayAndOverrideDuplicates([action.payload], state.notes)
      }
    }
    case addNote.FAILURE: {
      return {
        ...state,
        loading: false,
        success: false,
        error: true,
      }
    }
    case editNote.TRIGGER: {
      return { ...state, loading: true, error: false, success: false }
    }
    case editNote.SUCCESS: {
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        notes: mergeArrayAndOverrideDuplicates(state.notes, action.payload)
      }
    }
    case editNote.FAILURE: {
      return {
        ...state,
        loading: false,
        success: false,
        error: true,
      }
    }
    case getAllNotes.TRIGGER: {
      return { ...state, notesListLoading: true, error: false, success: false, notes: [] }
    }
    case getAllNotes.SUCCESS: {
      return {
        ...state,
        notesListLoading: false,
        success: true,
        notes: action.payload.notes,
        meta: action.payload.meta,
        error: false,
      }
    }
    case getAllNotes.FAILURE: {
      return {
        ...state,
        notesListLoading: false,
        success: false,
        error: true,
      }
    }
    case showNote.TRIGGER: {
      return { ...state, loading: true, error: false, success: false }
    }
    case showNote.SUCCESS: {
      return {
        ...state,
        loading: false,
        success: true,
        selectedNote: action.payload,
        error: false,
      }
    }
    case showNote.FAILURE: {
      return {
        ...state,
        loading: false,
        success: false,
        error: true,
      }
    }
    case deleteNote.TRIGGER: {
      return { ...state, loading: true, error: false, success: false }
    }
    case deleteNote.SUCCESS: {
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        notes: mergeArrayAndOverrideDuplicates(state.notes, +action.payload.id)
      }
    }
    case deleteNote.FAILURE: {
      return {
        ...state,
        loading: false,
        success: false,
        error: true,
      }
    }
    default:
      return state
  }
}
